/*
 * cr-smooth-scroll.js — initialize Lenis smooth scrolling (self-hosted).
 * ----------------------------------------------------------------------
 * Loaded only when the "Smooth scrolling" theme setting is on. Lenis v1
 * smooths the NATIVE scroll position (it doesn't transform a wrapper), so
 * position:fixed backdrops/header and our scrollY-based parallax/auto-hide
 * keep working — just smoothed.
 *
 * Fails safe to native scrolling when:
 *   - the lenis.min.js asset hasn't been added yet (Lenis undefined),
 *   - the visitor prefers reduced motion (accessibility),
 *   - we're in the theme editor (so it doesn't fight section selection),
 *   - the browser is WebKit (Safari desktop + ALL iOS browsers). Lenis drives
 *     the scroll position from JS each frame, and WebKit repaints
 *     position:fixed elements a frame behind it, so our fixed full-viewport
 *     backdrop + fixed header visibly judder ("MacOS Safari position:fixed
 *     jitter", lenis #103 — blocked, no upstream fix). WebKit's native scroll
 *     is already smooth, so we use it there and keep Lenis for Blink/Gecko.
 *
 * It also PAUSES itself whenever the page is intentionally scroll-locked —
 * the entrance gate (html.cr-entrance-active) or a drawer/menu lock
 * (body overflow:hidden, set by the header/cart JS) — and resumes after, so
 * Lenis never fights those locks.
 */
(function () {
  if (typeof Lenis === 'undefined') return; // lib not added yet -> native scroll
  if (window.Shopify && window.Shopify.designMode) return; // editor: leave native
  if (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  // WebKit -> native scroll (position:fixed jitter, lenis #103). navigator.vendor
  // starts with "Apple" for desktop Safari AND every iOS browser (all WebKit);
  // the iOS UA/touch check is a belt-and-braces fallback for any iOS browser
  // that doesn't report the Apple vendor.
  var ua = navigator.userAgent || '';
  var isIOS =
    /iP(hone|ad|od)/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isAppleWebKit = (navigator.vendor || '').indexOf('Apple') === 0;
  if (isAppleWebKit || isIOS) return;

  var lenis = new Lenis({
    duration: 1.05,
    smoothWheel: true,
    syncTouch: true, // smooth touch too (scope: everywhere)
  });
  window.lenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // Stop while a scroll-lock is active; resume when it clears.
  function syncLock() {
    var locked =
      document.documentElement.classList.contains('cr-entrance-active') ||
      document.body.style.overflow === 'hidden';
    if (locked) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }
  syncLock();

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(syncLock);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
    });
  }
})();
